// TODO(placeholder): replace with real client testimonials before
// production launch. Anonymised by design — names withheld at the
// principal's request.
export const TESTIMONIALS = [
    {
        quote:
            "They understood the brief before we finished briefing them. The result feels less like an installation and more like the home was always supposed to behave this way.",
        attribution: "Private Client · Bel Air Estate",
    },
    {
        quote:
            "We needed a partner the principals would never have to think about. They've been invisible in exactly the right way for three years.",
        attribution: "Family Office · Aspen Compound",
    },
    {
        quote:
            "Every system in the house anticipates us. We've stopped reaching for switches and remotes — and we've stopped noticing the technology entirely.",
        attribution: "Private Client · Hudson Valley Residence",
    },
];
